import { Link } from "react-router-dom";

const S = {
  page: {
    backgroundColor: "#FFF4B8",
    minHeight: "100vh",
    fontFamily: "Arial, sans-serif",
    color: "#111",
    fontSize: "15px",
    lineHeight: "1.6",
  },
  wrap: {
    maxWidth: "660px",
    margin: "0 auto",
    padding: "36px 20px 60px",
  },
  h1: {
    fontFamily: "Arial",
    fontWeight: "bold",
    fontSize: "22px",
    margin: "0 0 20px",
    paddingBottom: "10px",
    borderBottom: "1px solid #bbb",
  },
  h2: {
    fontFamily: "Arial",
    fontWeight: "bold",
    fontSize: "15px",
    margin: "20px 0 6px",
  },
  p: {
    margin: "0 0 12px",
    fontFamily: "Arial",
    fontSize: "15px",
  },
  back: {
    color: "blue",
    textDecoration: "underline",
    fontFamily: "Arial",
    fontSize: "15px",
  },
};

export default function Privacy() {
  return (
    <div style={S.page}>
      <div style={S.wrap}>
        <h1 style={S.h1}>Privacy</h1>

        <p style={S.p}>
          This site is designed to know as little about you as practical.
        </p>
        <p style={S.p}>
          You don&rsquo;t need an account, name, email address, phone number, or profile to participate.
        </p>

        <h2 style={S.h2}>What we store</h2>
        <p style={S.p}>
          If you post an idea, we store the idea, when it was posted, its help count, and whether it has been hidden or reported.
        </p>
        <p style={S.p}>
          If you report an idea, we record that it was reported, not who reported it.
        </p>
        <p style={S.p}>
          Your browser remembers which ideas you&rsquo;ve helped or reported and keeps a deletion credential that lets you delete ideas you submitted from that browser.
        </p>
        <p style={S.p}>
          We don&rsquo;t use this information to create a profile of you or connect your different submissions.
        </p>

        <h2 style={S.h2}>Spam and moderation</h2>
        <p style={S.p}>
          The site temporarily processes network information to prevent spam, but does not attach your IP address to ideas or help signals or store it in the database.
        </p>
        <p style={S.p}>
          Idea text is checked by a third-party automated moderation service before publication.
        </p>

        <h2 style={S.h2}>Visits</h2>
        <p style={S.p}>
          We keep approximate daily and total counts of browsers that visit the site.
        </p>
        <p style={S.p}>
          To do this without using your IP address, your browser stores a random identifier. The site uses privacy-preserving versions of that identifier to tell whether that browser has already been counted today or since the participant count was last reset.
        </p>
        <p style={S.p}>
          Different devices or browsers may count separately, and clearing browser storage may cause the same browser to be counted again.
        </p>
        <p style={S.p}>
          We don&rsquo;t connect these identifiers to your ideas, help signals, reports, or deletion credentials.
        </p>

        <h2 style={S.h2}>Hosting</h2>
        <p style={S.p}>
          The platform currently hosting this site may collect technical and usage information, including IP address, browser/device information, page views and interactions, and may record sessions.
        </p>
        <p style={S.p}>
          Text entered into the idea box and password fields is configured to be masked from session recordings.
        </p>
        <p style={S.p}>
          This site does not use advertising trackers, browser fingerprinting, personalized advertising, or visitor profiles.
        </p>

        <p style={{ ...S.p, marginTop: "28px" }}>
          <Link to="/" style={S.back}>Back</Link>
        </p>
      </div>
    </div>
  );
}
